// extracted by mini-css-extract-plugin
export default {"badge":"badge--ooAUr","success":"success--Qp80a"};